import React from 'react'
import { Card, CardContent, Grid } from '@material-ui/core'
import { components, constants, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import NaCountryCodeKeys from 'src/constants/locale/key/NaCountryCode'
import NaCountryCodeApiUrls from 'src/apiUrls/NaCountryCodeApiUrls'

const {
  card: { CngSimpleCardHeader },
  table: { CngCrudTable, useDefaultNotification },
} = components

const {
  locale: {
    key: { UiComponentKeys },
  },
} = constants

function TablePage(props) {
  const {
    location: { pathname },
    showNotification,
  } = props

  const notification = useDefaultNotification(showNotification)
  const { translate } = useTranslation([Namespace.UI_COMPONENT, Namespace.NA_COUNTRY_CODE])

  const title = translate(Namespace.NA_COUNTRY_CODE, NaCountryCodeKeys.TITLE)
  const tableTitle = translate(Namespace.UI_COMPONENT, UiComponentKeys.Table.TITLE, {
    nameTitleised: title,
  })

  const columns = [
    { field: 'code',          title: translate(Namespace.NA_COUNTRY_CODE, NaCountryCodeKeys.CODE) },
    { field: 'descriptionEn', title: translate(Namespace.NA_COUNTRY_CODE, NaCountryCodeKeys.DESCRIPTION_EN) },
    { field: 'indicator',     title: translate(Namespace.NA_COUNTRY_CODE, NaCountryCodeKeys.INDICATOR) },
    { field: 'intlcode',      title: translate(Namespace.NA_COUNTRY_CODE, NaCountryCodeKeys.INTLCODE) },
    { field: 'active',        title: translate(Namespace.NA_COUNTRY_CODE, NaCountryCodeKeys.ACTIVE), type: 'boolean' },
  ]

  return (
    <Card>
      <CngSimpleCardHeader title={tableTitle} />
      <CardContent>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CngCrudTable
              {...props}
              fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
              addRoute={`${pathname}/add`}
              columns={columns}
              del={{ url: NaCountryCodeApiUrls.DELETE }}
              editRoute={`${pathname}/edit`}
              fetch={{ url: NaCountryCodeApiUrls.GET }}
              fetchCustomData={{ codeMType: 'NACountryCode' }}
              idAccessor='id'
              notification={notification}
              viewRoute={`${pathname}/view`}
              options={{
                pageSize: 10,
                pageSizeOptions: [10, 20, 50, 100, 500, 1000],
              }}
            />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  )
}

export default TablePage
